
(function (window, document, jQuery, undefined) {

    // map to local vars
    var $ = jQuery.noConflict();
    var $document = $(document);

    // get links
    var $globalNavLinks = $('.kit-global-navbar__container .kit-global-navbar__list:first  .kit-global-navbar-item__link');

    // do magic
    $document.ready(function () {
        $globalNavLinks.attr('target', '_blank');
    });

})(window, document, jQuery);
